import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { HomeComponent } from './features/home/home.component';
import { CallbackComponent } from './features/callback/callback.component';
import { RegisterComponent } from './features/register/register.component';
import { RecoveryPasswordComponent } from './features/recovery-password/recovery-password.component';
import { AuthFlowSelectorComponent } from './feature/auth-flow-selector/auth-flow-selector.component';

export const routes: Routes = [
    { path: '',   redirectTo: 'authflow', pathMatch: 'full' },
    { path: 'authflow',   component: AuthFlowSelectorComponent },
    { path: 'discovery',   component: HomeComponent },
    { path: 'register',   component: RegisterComponent },
    { path: 'login', component: LoginComponent },
    { path: 'recovery/password', component: RecoveryPasswordComponent },
    { path: 'callback', component: CallbackComponent },
    { path: '**',  redirectTo: 'authflow'} // Wildcard page not ready yet, for now will use login page
];
